import _ from 'lodash';

export function checkCustomFieldsChange(prevCF, cf) {
  return !_.isEqual(prevCF, cf);
}

export function getSelected(allFields, config, isGlobal) {
  return _(allFields)
    .map(cf => {
      const key = isGlobal ? `selectedGlobal${cf}` : `selected${cf}`;
      if (!!config[key]) {
        return {
          fieldId: cf,
          values: config[key]
        };
      }
      return null;
    })
    .filter(cf => !!cf)
    .value();
}

export function getAll(allFields, config) {
  return _(allFields)
    .map(cf => {
      const key = `all${cf}`;
      if (!!config[key]) {
        const values = _.map(config[key], c => {
          return c.value;
        });
        return {
          fieldId: cf,
          values
        };
      }
      return null;
    })
    .filter(cf => !!cf)
    .value();
}

export function hasLabels(app, allFields) {
  const fields = {
    jira: 'priority',
    asana: 'tags',
    azure: 'work item type',
    trello: 'labels',
    file: ['priority', 'work item type']
  };
  return (
    fields[app] &&
    _.some(allFields, af => {
      return af === fields[app] || (_.isArray(fields[app]) && fields[app].indexOf(af) > -1);
    })
  );
}

export function getLabelField(app) {
  const fields = {
    jira: 'priority',
    asana: 'tags',
    azure: 'work item type',
    trello: 'labels'
  };

  return fields[app];
}

export function areMembersAllowed(hasMembers, dashboard) {
  if (!hasMembers || !dashboard) {
    return false;
  }

  return _.indexOf(dashboard.selectedFields, 'assignees') > -1 || _.indexOf(dashboard.selectedFields, 'members') > -1;
}

export default {
  checkCustomFieldsChange,
  getSelected,
  getAll,
  hasLabels,
  getLabelField,
  areMembersAllowed
};
